module.exports = __webpack_public_path__ + "img/invoiceVoidAct.4b51f91e.png";